import React from "react";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";
import { ExternalLinkButton } from "../../../components/ExternalLinkButton";
import { ButtonInternalLink } from "../../../components/NewButtons";

type LargeLinkCardProps = {
  icon?: React.ReactNode;
  header: string;
  subtitle: string;
  isExternalLink?: boolean;
  to: string;
  buttonText: string;
};

export const LargeWidget = ({
  icon,
  header,
  subtitle,
  isExternalLink,
  to,
  buttonText,
}: LargeLinkCardProps) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center p-5 b-4px h-100"
      style={{ gap: "24px", backgroundColor: colors.ctaLight }}
    >
      <div
        className="d-flex flex-column align-items-center justify-content-center b-4px"
        style={{
          width: "48px",
          height: "48px",
          backgroundColor: colors.ctaMain,
        }}
      >
        <StyledText color={colors.white} className="bodyTextSemibold mb-0">
          {icon && icon}
        </StyledText>
      </div>
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ gap: "8px" }}
      >
        <StyledText
          className="bodyHeaderOneSemi mb-0"
          color={colors.textPrimary}
        >
          {header}
        </StyledText>
        <StyledText
          className="bodyTextRegular mb-0 text-center"
          color={colors.textSecondary}
        >
          {subtitle}
        </StyledText>
      </div>
      {isExternalLink ? (
        <ExternalLinkButton
          backgroundColor={colors.ctaMain}
          hoverColor={colors.ctaSecondaryOne}
          textColor={colors.white}
          href={to}
          text={buttonText}
        ></ExternalLinkButton>
      ) : (
        <ButtonInternalLink to={to}>{buttonText}</ButtonInternalLink>
      )}
    </div>
  );
};
